import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedFeatureComponentsModule } from '@digilize/shared/feature/components/src';
import { LangComponentsModule } from '@digilize/shared/feature/modules/i18n/src';
import { SharedUiComponentsModule } from '@digilize/shared/ui/components/src';
import { SharedUiMaterialModule } from '@digilize/shared/ui/material/src';
import { SharedUtilsPipesModule } from '@digilize/shared/utils/pipes/src';
import { TranslateModule } from '@ngx-translate/core';
import player from 'lottie-web';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { NgxCaptchaModule } from 'ngx-captcha';
import { LottieModule } from 'ngx-lottie';

import { PipesModule } from '../pipes/pipes.module';
import { AccountFormsComponent } from './account-forms/account-forms.component';
import { CityInputComponent } from './city-input/city-input.component';
import { ConfirmDeleteAccountComponent } from './confirm-delete-account/confirm-delete-account.component';
import { ControlBarComponent } from './control-bar/control-bar.component';
import { ProfileMenuComponent } from './profile-menu/profile-menu.component';
import { EducationStageComponent } from './education-stage/education-stage.component';
import { LinkExpiredComponent } from './link-expired/link-expired.component';
import { ManagePasswordComponent } from './manage-password/manage-password.component';
import { ManageStartComponent } from './manage-start/manage-start.component';
import { StepControlBarComponent } from './step-control-bar/step-control-bar.component';
import { SuccessPopupComponent } from './success-popup/success-popup.component';
import { YourExperienceComponent } from './your-experience/your-experience.component';

@NgModule({
  declarations: [
    EducationStageComponent,
    ControlBarComponent,
    YourExperienceComponent,
    AccountFormsComponent,
    ConfirmDeleteAccountComponent,
    ManagePasswordComponent,
    ProfileMenuComponent,
    ManageStartComponent,
    LinkExpiredComponent,
    SuccessPopupComponent,
    StepControlBarComponent,
    CityInputComponent,
  ],
  imports: [
    CommonModule,
    SharedUiMaterialModule,
    LazyLoadImageModule,
    TranslateModule,
    CdkAccordionModule,
    SharedUiComponentsModule,
    NgxCaptchaModule,
    FormsModule,
    ReactiveFormsModule,
    SharedUtilsPipesModule,
    InlineSVGModule,
    RouterModule,
    SharedFeatureComponentsModule,
    LangComponentsModule,
    PipesModule,
    LottieModule.forRoot({ player: () => player }),
  ],
  exports: [
    CommonModule,
    SharedUiMaterialModule,
    LazyLoadImageModule,
    TranslateModule,
    CdkAccordionModule,
    SharedUiComponentsModule,
    NgxCaptchaModule,
    ReactiveFormsModule,
    SharedUtilsPipesModule,
    InlineSVGModule,
    RouterModule,
    EducationStageComponent,
    ControlBarComponent,
    YourExperienceComponent,
    AccountFormsComponent,
    ConfirmDeleteAccountComponent,
    ManagePasswordComponent,
    ProfileMenuComponent,
    StepControlBarComponent,
    CityInputComponent,
  ],
})
export class SharedModule {}
